import React from "react";
import defaultAvatar from "../images/user.png";
import "../styles/ClubPage.css";

const StudentMembers = ({ clubData }) => {
    if (!clubData || !clubData.students) return <p>Loading student members...</p>;

    return (
        <>
            <h2>Student Members</h2>
            <div className="student-grid">
                {clubData.students.length > 0 ? (
                    clubData.students.map((student, index) => (
                        <div key={index} className="student-card">
                            <img
                                src={student.image?.startsWith("http") ? student.image : defaultAvatar}
                                alt={student.name}
                                className="student-avatar"
                            />
                            <span className="student-name">{student.name}</span>
                        </div>
                    ))
                ) : (
                    <p>No student members found.</p>
                )}
            </div>
        </>
    );
};

export default StudentMembers;
